//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Alert Type */
export const AlertType = {
    /** Gratitude looks for amounts larger than normal, or transactions that are earlier than usual. */
    Gratitude: 0,

    /** Follow Up looks for amounts smaller than normal, or transactions later than usual (or stopped occurring) */
    FollowUp: 1
} as const;

/** Alert Type */
export const AlertTypeDescription: Record<number, string> = {
    0: "Gratitude",

    1: "Follow-up"
};

/** Alert Type */
export type AlertType = typeof AlertType[keyof typeof AlertType];
